module.exports = __webpack_public_path__ + "img/power.eb6b65a1.png";